import { useQuery } from '@tanstack/react-query';
import type { PaginatedLineItemsDto, ListLineItemsQuery } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface LineItemsApiResponse {
  success: boolean;
  data: PaginatedLineItemsDto;
}

/**
 * Hook to fetch the paginated line items for a project.
 * Calls GET /projects/:projectId/line-items.
 * Disabled until a valid projectId is provided.
 */
export function useLineItems(projectId: number | undefined, query?: Partial<ListLineItemsQuery>) {
  return useQuery({
    queryKey: queryKeys.lineItems.list(projectId ?? 0, query),
    queryFn: async () => {
      const response = await apiClient.get<LineItemsApiResponse>(
        `/projects/${projectId}/line-items`,
        { params: query },
      );
      return response.data.data;
    },
    enabled: projectId != null && projectId > 0,
  });
}
